import React from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import parse from 'html-react-parser'

import { WPCF7Form } from '@/types'

export type ConsentFieldProps = {
  field: WPCF7Form['form'][0]
  formik: any
}

const ConsentField = ({ field, formik }: ConsentFieldProps) => {
  return (
    <>
      {field.label && field.labelPlacement !== 'hidden_label' && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: 'block',
            mb: 1,
            ...(formik.submitCount > 0 &&
              formik.errors[`input_${field.id}`] !== undefined &&
              formik.touched[`input_${field.id}`] !== undefined && {
                color: 'error.main'
              })
          }}
        >
          {field.label}
          {field.isRequired ? ' *' : ''}
        </Typography>
      )}
      <FormControlLabel
        control={
          <Checkbox
            id={`input_${field.id}`}
            checked={formik.values[`input_${field.id}`] || false}
            disabled={formik.isSubmitting}
            sx={{
              py: '4px',
              pr: 0
            }}
            disableRipple
            icon={
              <Box
                sx={(theme) => ({
                  width: '1.6rem',
                  height: '1.6rem',
                  backgroundColor: 'transparent',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: theme.shape.borderRadius1
                })}
              ></Box>
            }
            checkedIcon={
              <Box
                sx={(theme) => ({
                  width: '1.6rem',
                  height: '1.6rem',
                  backgroundColor: 'transparent',
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: theme.shape.borderRadius1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                })}
              >
                <Box
                  sx={(theme) => ({
                    width: '1rem',
                    height: '1rem',
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: '2px'
                  })}
                ></Box>
              </Box>
            }
            onChange={(e) => {
              formik.handleChange(e)
              formik.setFieldValue(`input_${field.id}_1`, e.target.checked ? '1' : '0', false)
            }}
            onBlur={formik.handleBlur}
          />
        }
        label={
          <Typography
            variant="textRegular"
            color="text.secondaryContrastText"
            sx={{
              ml: 2,
              '& a': {
                textDecoration: 'underline'
              },
              ...(formik.errors[`input_${field.id}`] !== undefined &&
                formik.touched[`input_${field.id}`] !== undefined && {
                  color: 'error.main'
                })
            }}
          >
            {field.checkboxLabel?.includes('<a') ? parse(field.checkboxLabel) : field.checkboxLabel}
          </Typography>
        }
        sx={{
          alignItems: 'flex-start',
          ...(formik.isSubmitting && {
            pointerEvents: 'none',
            opacity: 0.4
          })
        }}
      />
    </>
  )
}

export default ConsentField
